import React, {useEffect, useState} from "react";
import {QuestionCircleOutlined} from '@ant-design/icons';
import {Link} from "react-router-dom";
import Dialog from "../../lib/Dialog";
import general from "../../general";
import {useLockFn, useScroll, useUpdate} from "ahooks";
import Image from "../../lib/Image";
import moment from "moment";

export default props => {
  useEffect(() => {
    props.setOperate(<Link to="/task/tryplay-explain"
                           className="task-tryplay-operate"><QuestionCircleOutlined/></Link>);
  }, []);
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [datas, setDatas] = useState([]);
  const load = () => {
    if (loading) {
      return;
    }
    setLoading(true);
    Dialog.loading();
    general.axios.post('/user/tryPlay/getList')
      .finally(() => {
        setLoading(false);
        Dialog.close();
      })
      .then(res => {
        setLoaded(true);
        let {status, data} = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
          return;
        }
        setDatas(data.list.map(item => {
          item.s = item.surplus / item.total;
          if (item.s > 1) {
            item.s = 1;
          }
          if (!item.s) {
            item.s = 0;
          }
          return item;
        }));
      })
      .catch(err => {
        Dialog.error(err.message);
      });
  }
  useEffect(() => {
    if (props.active && !loaded) {
      load();
    }
  }, [props]);
  const scroll = useScroll();
  useEffect(() => {
    if (props.active && loaded) {
      if (scroll.top < -80) {
        load({page: 1});
      }
    }
  }, [scroll, props.active]);

  const update = useUpdate();

  const receiveTask = useLockFn(async data => {
    Dialog.loading();
    general.axios.post('/user/tryPlay/receiveTask', {id: data.id})
      .finally(() => {
        Dialog.close();
      })
      .then(res => {
        let {status} = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
          return;
        }
        // data.is_receive = true;
        // update();
        load()
      })
      .catch(err => {
        Dialog.error(err.message);
      });
  });

  const receiveReward = useLockFn(async data => {
    Dialog.loading();
    await general.axios.post('/user/tryPlay/receiveReward', {id: data.id})
      .finally(() => {
        Dialog.close();
      })
      .then(res => {
        let {status} = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
          return;
        }
        // data.is_receive_coin = true;
        // update();
        load()
      })
      .catch(err => {
        Dialog.error(err.message);
      });
  });

  return <div className="task-tryplay" >
    <div className="tryplay-head" style={{backgroundImage:"url(/resources/welfare/try_bg.png)"}}>
      <h1>任务步骤</h1>
      <p>1.领取任务</p>
      <p>2.创建小号，达到试玩要求</p>
      <p>3.返回该页面领取奖励</p>
      <p>注意：需先领取任务后，再创建小号进行试玩，任务才可生效</p>
    </div>
    <div className="tryplay-body">
      {datas.map((item, index) => <Link to={'/game?id='+item.appid+'&mid=' + item.gameid} className="item">
        <div className="icon"><Image src={item.game_logo}/></div>
        <div className="info">
          <div className="name">
            {/* {item.game_name} */}
            <div className={" " + (item.nameRemark ? " name-new" : "")}>
              {item.game_name}
            </div>
            {item.nameRemark ? <div className="nameRemark-new">{item.nameRemark}</div> : null}
          </div>
          <div className="time">
            有效期:
            {moment(item.start_time * 1000).format('MM月DD日')}
            ~
            {moment(item.end_time * 1000).format('MM月DD日')}
          </div>
          <div className="desc">
            <div className="require">要求：{item.require}</div>
            {/* <div className="reward">奖：{item.coin}金币</div> */}
          </div>
          <div className="reward">
            奖励：{item.reward}
          </div>
        </div>
        <div className="operate">
          <div className="count">
            <svg width="50" height="50">
              <circle cx="25" cy="25" r="24" stroke-width="1" stroke="#D1D3D7" fill="none"></circle>
              <circle cx="25" cy="25" r="24" stroke-width="1" stroke="#00A5E0" fill="none"
                      stroke-dasharray={(Math.PI * item.s * 100) + ',' + (Math.PI * (1 - item.s) * 100)}>
              </circle>
            </svg>
            <div className="value">{item.surplus}</div>
            <div className="text">剩余</div>
          </div>
          {(() => {
            if (item.is_receive) {
              if (item.is_complete) {
                if (item.is_receive_coin) {
                  return <div className="btn success">已完成</div>;
                } else {
                  return <div className="btn" onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    receiveReward(item);
                  }}>领取奖励</div>;
                }
              } else {
                return <div className="btn ing">进行中</div>;
              }
            } else if (item.surplus) {
              return <div className="btn" onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                receiveTask(item);
              }}>领取</div>;
            } else {
              return <div className="btn disable">已领完</div>;
            }
          })()}
        </div>
      </Link>)}
    </div>
  </div>;
};